import { render, staticRenderFns } from "./datalist.vue?vue&type=template&id=ae0b2f6c"
import script from "./datalist.vue?vue&type=script&lang=js"
export * from "./datalist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports